<template>

<main>
  <h1 id="home-page-title">The University of Illinois at Chicago</h1>
  <fast-facts/>
  <call-to-action/>
  <div class="ms-grid zero-margin extra-wide-grid full">
    <spotlight-block></spotlight-block>
    <today-block></today-block>
    <key-message2020-block></key-message2020-block>
  </div>
  <campus-reminders/>
</main>

</template>

<script>

// Components
// import FastFacts from '@/components/ui-components/FastFacts.vue';
// import CallToAction from '@/components/ui-components/CallToAction.vue';
// import CampusReminders from '@/components/ui-components/CampusReminders.vue';
// import SpotlightBlock from '@/components/ui-components/SpotlightBlock.vue';
// import KeyMessage2020Block from '@/components/ui-components/KeyMessage2020Block.vue';
// import TodayBlock from '@/components/ui-components/TodayBlock.vue';
const FastFacts = () => import('@/components/ui-components/FastFacts.vue');
const CallToAction = () => import('@/components/ui-components/CallToAction.vue');
const CampusReminders = () => import('@/components/ui-components/CampusReminders.vue');
const SpotlightBlock = () => import('@/components/ui-components/SpotlightBlock.vue');
const KeyMessage2020Block = () => import('@/components/ui-components/KeyMessage2020Block.vue');
const TodayBlock = () => import('@/components/ui-components/TodayBlock.vue');

export default {
  name: 'HomeBody',
  components: {
    FastFacts,
    CallToAction,
    CampusReminders,
    SpotlightBlock,
    KeyMessage2020Block,
    TodayBlock,
  },
};

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

</style>
